import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SubttasksLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 4, height: 4, x: 18, y: 9, stroke: "currentColor", rx: 2, transform: "rotate(90 18 9)" }),
            React.createElement("rect", { width: 4, height: 4, x: 18, y: 17, stroke: "currentColor", rx: 2, transform: "rotate(90 18 17)" }),
            React.createElement("rect", { width: 4, height: 4, x: 3, y: 7, stroke: "currentColor", rx: 2, transform: "rotate(-90 3 7)" }),
            React.createElement("path", { stroke: "currentColor", d: "M5 8v7c0 1.886 0 2.828.586 3.414S7.114 19 9 19h5" }),
            React.createElement("path", { stroke: "currentColor", d: "M5 7c0 1.886 0 2.828.586 3.414S7.114 11 9 11h5" })));
}
const SubttasksLight = forwardRef(_SubttasksLight);
export { SubttasksLight };
